module.exports = __webpack_public_path__ + "static/img/tzzz.88f64ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/tzzz.png
// module id = //oh
// module chunks = 0